<script lang="ts" setup>
interface BaseSkeletonProps {
  height?: number;
  width?: number;
  fullwidth?: boolean;
}

withDefaults(defineProps<BaseSkeletonProps>(), {
  height: 20,
  width: 70,
  fullwidth: false,
});
</script>

<!-- TODO: add fullHeight logic -->
<template>
  <div class="skeleton__wrapper" :style="{ height: `${height}px` }">
    <div
      class="skeleton skeleton-animation"
      :style="{
        height: `${height}px`,
        width: fullwidth ? '100%' : `${width}px`,
      }"
    />
  </div>
</template>

<style lang="scss" scoped>
.skeleton {
  background: var(--colorBgSrfTertiaryAlpha);
  border-radius: var(--radius-2);

  &__wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.skeleton-animation {
  position: relative;
  overflow: hidden;
  isolation: isolate;

  &::after {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
      90deg,
      transparent 0,
      rgb(255 255 255 / 0.3) 30%,
      rgb(255 255 255 / 0.4) 70%,
      transparent
    );
    transform: translateX(-100%);
    animation: shimmer 3s infinite;
    content: '';
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
